jQuery(document).ready(function() {
  
  /* Open Cart Drawer Code */
  $('#HeaderCartTrigger').on('click', function () {
    if (window.location.pathname === '/cart') {
      return;
    }
    setTimeout(function () {
      $(".site-header__cart").addClass("is-active");
      $('header-section').addClass("cart-open");
    }, 10); 
  });
  
  /* Close Cart Drawer Code */
  $(".js-close-header-cart").click(function(){
    $(this).closest(".site-header__cart").removeClass("is-active");
    $('header-section').removeClass("cart-open");
    $('body').removeAttr('style');
    $('#HeaderCartTrigger').attr('aria-expanded', 'false');
  });

                                 
  /* Product page accordion Code */
  $(document).on("click", ".ct-short-description-heading-main", function () {
      $(".ct-short-description-inner").not($(this).closest(".ct-short-description-inner")).removeClass("is_open");
      $(this).closest(".ct-short-description-inner").toggleClass("is_open");
      // $(document).on("click", ".ct-short-description-heading-main", function () {
      //     var $parent = $(this).closest(".ct-short-description-inner");
      //          $parent.toggleClass("is_open");
      // });
  });

// Run on variant change start
  $(document).on("change",".ct-variant-picker-main select",function(e){        
    let selectElement=jQuery(this);
    var selectedOption = $(selectElement).find('option:selected');
        var newPrice = selectedOption.attr('data-price');
        var originalPrice = selectedOption.attr('data-cprice');
        var isSoldOut = selectedOption.attr('data-soldout') === "sold-out"; // Check if sold out
        var parentContainer = $(selectElement).closest('.ct_product_detials');    
        parentContainer.find('.grid-product__price--current .money').text('Rs. ' + newPrice);
        parentContainer.find('.grid-product__price--original .money').text('Rs. ' + originalPrice);    
        var addToCartButton = parentContainer.find('.add-to-cart');
        var addToCartText = addToCartButton.find('.btn-text');
      // console.log(originalPrice)
        if (isSoldOut) {
            addToCartText.text('Sold Out');
            addToCartButton.prop('disabled', true).addClass('disabled'); // Disable button and add class
        } else {
            addToCartText.text('Add to Cart');
            addToCartButton.prop('disabled', false).removeClass('disabled'); // Enable button and remove class
        }
    })
    $(".ct-variant-picker-main select").each(function () {
        $(this).trigger("change");
    });
// Run on variant change end  
let alertTriggered = false; 
function checkVisibility() {
    if (!alertTriggered && $('.ct-Recommendations-main').is(':visible') && isElementInView('.ct-Recommendations-main')) {
     setTimeout(() => { 
      $(".ct-variant-picker-main select").each(function () {
          $(this).trigger("change");
      });
    }, 1000);
        alertTriggered = true;
        $(window).off('scroll resize', checkVisibility);
    }
}
function isElementInView(element) {
    let $elem = $(element);
    let elemTop = $elem.offset().top;
    let elemBottom = elemTop + $elem.height();
    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + $(window).height();        
    return elemBottom > viewportTop && elemTop < viewportBottom;
}
$(window).on('scroll resize', checkVisibility);
checkVisibility(); 
//[Product page You may also like]  Run on variant change end 
  
});




function syncStickyCartPrice() {
  // Get main product price block
  var $mainContainer = $('.block-price__container').first();

  // Extract prices
  var mainPrice = $mainContainer.find('.product__price > [aria-hidden="true"] > .money').last().text().trim();
  var mainComparePrice = $mainContainer.find('.secend_price .money').text().trim();

  // Extract savings text (e.g., "Save 25% more")
  var mainSaveText = $mainContainer.closest('.block-price').find('.block-price__save').text().trim();

  // Target sticky cart price block
  var $stickyContainer = $('.ct-cart-stick-price .block-price__container');
  var $stickyBlock = $stickyContainer.closest('.block-price');

  // Update selling price
  $stickyContainer.find('.product__price > [aria-hidden="true"] > .money').last().text(mainPrice);
  $stickyContainer.find('.product__price .visually-hidden .money').text(mainPrice);

  // Update compare at price
  $stickyContainer.find('.secend_price .money').text(mainComparePrice);
  $stickyContainer.find('.visually-hidden.dd .money').text(mainComparePrice);

  // Update Save % text
  $stickyBlock.find('.block-price__save').text(mainSaveText);
}

// Call on variant change
$(document).on('change', '[name="id"]', function () {
  setTimeout(syncStickyCartPrice, 300);
});


$(document).ready(function () {
  // Unbind any existing click events from sticky cart button
  $('.ct-cart-stick-price-btn .add-to-cart').off('click');

  // Bind new click to trigger the main add-to-cart button
  $('.ct-cart-stick-price-btn .add-to-cart').on('click', function (e) {
    e.preventDefault(); // prevent default action
    e.stopPropagation(); // stop any bubbling

    // Trigger the actual product page add to cart button
    $('.ct-pdp-buy-main .add-to-cart').trigger('click');
  });
});
